"use strict";

define(['app', './base'], function (app, Helper) {
  return Helper.extend({
    switchClass: function switchClass() {
      this.$el.children().toggleClass('is-hidden is-active');
    },
    initialize: function initialize() {
      var self = this;
      this.$el.on('click', function () {
        self.switchClass();
      });
    }
  });
});